import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "../../../utils/store";

export const usePageBuilderStore = defineStore("page-builder", () => {
  const showGrid = useLocalStorage("showGrid", false);
  const isDragging = useLocalStorage("dragging", false);

  function setShowGrid(value) {
    showGrid.value = value;
  }

  return {
    // State
    showGrid,
    isDragging,

    // Actions
    setShowGrid,
  };
});
